import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  SchoolModuleBatch,
  SchoolModuleEvent,
  moduledetails,
  modulemedia,
} from 'src/app/models/module/moduledetails';
import { Observable } from 'rxjs';
import { isNumeric, data } from 'jquery';
import { of } from 'rxjs';
import { UtilService } from '../util.service';
import { FeatureGroups, SchoolViewModel } from 'src/app/models/school/schooladminitem.model';
import { PaymentService } from '../payment.service';
import { ToastrService } from 'ngx-toastr';
import { DetectlocationService } from '../detectlocation.service';
import { PaymentiframeComponent } from 'src/app/reuseableui/paymentiframe/paymentiframe.component';

declare const $: any;

@Injectable({
  providedIn: 'root',
})
export class ModulemanagementService {
  setModuleStudentsAccessDays(moduleId: number, accessDays: number) {
    return this.http.post(
      `${this.rootURL}modules/updateschoolmodulestudentsaccessdays`,
      { moduleId, accessDays },
      { headers: this.req_headers }
    );
  }
  uploadenrolfile(moduleid: any, file: any) {
    let formData = new FormData();
    formData.append('file', file[0], file[0].name);
    return this.http.post(
      this.rootURL + `modules/batchenrollstudents?moduleid=${moduleid}`,
      formData
    );
  }
  // hasliveclass(id: any) {
  //   return this.http.get(
  //     this.rootURL + `moduleclass/hasliveveclass?moduleid=${id}`
  //   );
  // }
  userhasenrollmentinschool() {
    return this.http.get(this.rootURL + `modules/hasenrollmentinschool`);
  }
  getSkippedClasses(id: any) {
    return this.http.get(
      this.rootURL + `modules/getskippedclasses?moduleid=${id}`
    );
  }
  getCourseprogressDetails() {
    return this.http.get(this.rootURL + `modules/getcourseprogressdetails`);
  }
  enrollformodule(data: any) {
    return this.http.post(
      this.rootURL + `modules/enrollformodule?ModuleID=${data.moduleId}&batchid=${data.batchId}`,
      data
    );
  }
  uploadModuleLogo(moduleid: number, file: File) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(
      this.rootURL + `modules/updatemodulelogo?moduleid=${moduleid}`,
      formData
    );
  }

  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly ADD_USER = 'ADD';
  readonly REMOVE_USER = 'REMOVE';
  readonly ENABLE_USER = 'ENABLE';
  readonly DISABLE_USER = 'DISABLE';
  req_headers = new HttpHeaders({
    'content-type': 'application/json',
    accept: 'application/json',
  });
  constructor(private http: HttpClient, private util: UtilService, 
    private locationService: DetectlocationService) {}

  getModuleDetails(moduleID: number) {
    var response = this.http.get(
      this.rootURL + `modules/view?moduleID=${moduleID}`
    );
    return response;
  }
  getModuleInfo(moduleID: number) {
    //debugger;
    var response = this.http.get(
      this.rootURL + `modules/getmoduleinfo?moduleID=${moduleID}`
    );
    return response;
  }
   getCourseCalendarInfo(pagesize: number, page: number) {
    var response = this.http.get(
      this.rootURL + `modules/getcoursecalendarinfo?pageSize=${pagesize}&page=${page}`
    );
    return response;
  }

  // getMyEnrolledModules(){
  //   return this.http.get(this.rootURL + `modules/getmyenrolledmodules`);
  // }

  getMyEnrolledModulesURL() {
    //debugger
    return this.rootURL + `modules/getmyenrolledmodules?z=1`;
  }

  getSearchModulesURL(searchstring: string, filter: any) {
    return (
      this.rootURL +
      `modules/search?searchstring=${encodeURI(searchstring)}&filter=${filter}`
    );
  }

  getSchoolModulesURL(schoolid: number) {
    return this.rootURL + `modules/getschoolmodules?schoolId=${schoolid}`;
  }

  createModule(data: moduledetails) {
    // debugger;
    // if(data.requireEnrollment=="1")
    // {
    //   data.requireEnrollment=true;
    // }
    // else
    // {
    //   data.requireEnrollment=false;
    // }
    //var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.post(this.rootURL + 'modules/create', data, {
      headers: this.req_headers,
    });
  }

  getModuleUsers(ModuleID: number): Observable<any> {
    return this.http.get(
      this.rootURL + `modules/moduleadmins?ModuleID=${ModuleID}`
    );
  }

  deleteModule(id: number) {
    //var req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });
    return this.http.delete(this.rootURL + `modules/delete?id=${id}`, {
      headers: this.req_headers,
    });
  }

  manageUser(_ModuleID: number, targetEmail: string, actionType: any) {
    let data = {
      moduleID: _ModuleID,
      targetEmail: targetEmail,
      userAction: actionType,
    };
    return this.http.post(this.rootURL + `modules/managemoduleadmin`, data);
  }
  enrollByAdmin(data: any){
    return this.http.post(this.rootURL + `modules/enrollbyadmin`, data);
  }
  sendStudentInvite(data: any) {
    return this.http.post(this.rootURL + `modules/invitestudent`, data);
  }
  getModules(modulesurl: string, offset: number, modulesPerPage: number) {
    //debugger;
    if (isNaN(modulesPerPage)) {
      modulesPerPage = 6;
    }
    return this.http.get(
      `${modulesurl}&modulesPerPage=${modulesPerPage}&offset=${offset}`
    );
  }

  getMedia(moduleid: number) {
    return this.http.get<modulemedia[]>(
      this.rootURL + `modules/getmedia?moduleid=${moduleid}`
    );
  }

  getMediaStatus(schoolid: number, filesize: number) {
    return this.http.get<boolean>(
      this.rootURL + `school/checkspace?school=${schoolid}&filesize=${filesize}`
    );
  }

  uploadMediaFilePart(moduleid, uploadid, blob, chunkNumber) {
    var fd = new FormData();
    fd.append('moduleid', moduleid);
    fd.append('data', blob);
    fd.append('chunknumber', chunkNumber);
    fd.append('uploadid', uploadid);

    return this.http.post(this.rootURL + `modules/uploadmediafile`, fd);
  }
  uploadRemoteMedia(url: string, moduleid: number, title){
    let formData = new FormData();
    formData.append("url", url);
    formData.append("moduleId", moduleid.toString());
    formData.append("title", title)
    return this.http.post(this.rootURL + `modules/uploadremotemediafile`, formData);
  }

  finishMediaFileUpload(
    moduleid,
    uploadid: string,
    filename: string,
    mimetype,
    title: string,
    size: number
  ) {
    var fd = new FormData();
    fd.append('moduleid', moduleid);
    fd.append('uploadid', uploadid);
    fd.append('filename', filename);
    fd.append('mimeType', mimetype);
    fd.append('title', title);
    fd.append('size', size.toString());

    return this.http.post(this.rootURL + `modules/finishuploadmediafile`, fd);
  }

  // createExternalMedia(moduleid, embedurl, uploadid, title){
  //   return this.http.post(this.rootURL + `modules/createexternalmedia`, {moduleid: moduleid, embedurl: embedurl, uploadid: uploadid, title: title}, { headers: this.req_headers })
  // }

  retryMediaProcessing(moduleid: number, uploadid: string){
    return this.http.post(
      this.rootURL +
        `modules/retryfailedmediaprocess`, {moduleId : moduleid, uploadId : uploadid}
    );
  }
  getSingleMedia(moduleid: number, uploadid: string, context?: HttpContext) {
    return this.http.get<modulemedia>(
      this.rootURL +
        `modules/getsinglemedia?moduleid=${moduleid}&uploadid=${uploadid}`,
      context ? { context } : {}
    );
  }

  getSingleLegacyMedia(classid: number, sno: number) {
    return this.http.get<modulemedia>(
      this.rootURL +
        `modules/getsinglelegacymedia?classid=${classid}&sno=${sno}`
    );
  }

  deleteMedia(moduleid: number, uploadid: string) {
    return this.http.post(
      this.rootURL +
        `modules/deletemedia?moduleid=${moduleid}&uploadid=${uploadid}`,
      {}
    );
  }

  getModuleLogoURL(moduleid: number): Observable<any> {
    return this.http.get(
      this.rootURL + `modules/getmodulelogo?moduleid=${moduleid}`
    );
  }
  // searchModules(searchstring: string){
  //   return this.http.get(this.rootURL + `modules/search?searchstring=${encodeURI(searchstring)}`);
  // }

  getModuleStudents(moduleid: number, page: number, limit: number, paramsForFilter: Array<any>, sortBy = '', sortAscending = false) {
    let object = {page: page, limit: limit, moduleId: moduleid, filters: paramsForFilter, sortBy: sortBy, sortAscending: sortAscending}
    return this.http.get(
      this.rootURL +
        `modules/getSchoolStudentsList`, {params: {data: JSON.stringify(object)}}
    );
  }

  getModuleStudentsStat(moduleId: number){
    return this.http.get(
      this.rootURL +
        `modules/getmodulestudentsstatsummary?moduleid=${moduleId}`
    );
  }

  getUnregisteredStudents(moduleid: number, page:number, limit: number, searchString = '', sortBy = '', sortAscending = true ) {
    return this.http.get(
      this.rootURL + `modules/moduleunregisteredlist`,
      { params: { moduleId: moduleid, page: page, limit: limit, searchString: searchString,
                  sortBy: sortBy, sortAscending: sortAscending } })
  }
  downloadModuleStudent(moduleid: number): Observable<any> {
    return this.http.get(
      this.rootURL + `modules/downloadschoolstudent?moduleid=${moduleid}`,
      { responseType: 'blob' }
    );
  }

  getModulePackageNames(moduleid: number) {
    return this.http.get<any[]>(
      `${this.rootURL}modules/getmodulepackagesnames?moduleId=${moduleid}`
    );
  }
  getAllSchoolModule(schoolId: number) {
    return this.http.get(
      `${this.rootURL}modules/getallschoolmodules?schoolid=${schoolId}`
    );
  }

  markModuleCompleted(moduleid: number) {
    return this.http.post(this.rootURL + `modules/markmodulecomplete?moduleId=${moduleid}`, {});
  }

  createModuleInviteMail(data: any) {
    return this.http.post(this.rootURL + `modules/createmoduleevent`, data);
  }

  testModuleInviteMail(data: any) {
    return this.http.post(this.rootURL + `modules/createtestmoduleevent`, data);
  }
  cancelModuleInviteMail(data: any) {
    return this.http.post(this.rootURL + `modules/cancelmoduleevent`, data);
  }
  async getModuleInvites(moduleid: number) {
    if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
      return [];
    }
    return this.http.get<SchoolModuleEvent[]>(
      this.rootURL + `modules/getemoduleevents?moduleid=${moduleid}`
    ).toPromise();
  }
  async getUpcomingModuleInvites(moduleid: number,classid:number) {
    if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
      return [];
    }
    return this.http.get<SchoolModuleEvent[]>(
      this.rootURL + `modules/getupcomingemoduleevents?moduleid=${moduleid}&classid=${classid}`
    ).toPromise();
  }
  async getAllUpcomingModuleInvites(schid: number) {
    if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
      return [];
    }
    return this.http.get<SchoolModuleEvent[]>(
      this.rootURL + `modules/getallupcomingemoduleevents?schoolid=${schid}`
    ).toPromise();
  }

  getModuleBatches(moduleid: number) {
    return this.http.get<SchoolModuleBatch[]>(
      this.rootURL + `modules/getmodulebatches?moduleId=${moduleid}`
    );
  }

  getStudentCalendarBatches(){
    return this.http.get<SchoolModuleBatch[]>(
      this.rootURL + `modules/getcalendarbatchesbystudent`
    );
  }

  getSchoolCalendarBatches_Admin(){
    return this.http.get<SchoolModuleBatch[]>(
      this.rootURL + `modules/getschoolcalendarbatchesforadmin`
    );
  }

  getEnrollmentModuleBatches(moduleid: number) {
    return this.http.get<SchoolModuleBatch[]>(
      this.rootURL + `modules/getmoduleenrollmentbatches?moduleId=${moduleid}`
    );
  }
  saveModuleBatch(data) {
    return this.http.post(
      this.rootURL + `modules/createmodulebatch`,data
    );
  }
  getBatchFromID(id){
    return this.http.get<SchoolModuleBatch>(
      this.rootURL + `modules/getmodulebatch?id=${id}`
    );
  }
  getCurrentModuleBatches(classId: number) {
    return this.http.get<SchoolModuleBatch[]>(
      this.rootURL + `modules/getcurrentmodulebatches?classId=${classId}`
    );
  }
  getStudentModuleStats(moduleid: number, studentid: number ){
    return this.http.get<any>(
      this.rootURL + `modules/getstudentmodulestats?moduleId=${moduleid}&studentId=${studentid}`
    );
  }

  private isAccountReady(regionId: number, 
    price: number,
    payments: PaymentService,
    school: SchoolViewModel): boolean {
    if (price > 0){
      if (regionId != 1){
        if (!school?.stripeAccountId)
          return false;
        payments.getStripeAccountStatus(school?.stripeAccountId).subscribe((data: any) => {
          if(data?.requirements?.length)
            return false;
        });
      }
      else if (regionId == 1 && !school?.accountNumber && !school?.accountName && !school?.bankId){
        return false;
      }
    }
    return true;
  }

  async enroll(allowBatches: boolean,
    batchId: number,
    price: number,
    payments: PaymentService,
    toastr: ToastrService,
    moduleId: number,
    school: SchoolViewModel,
    paymentModal: any,
    loadingPaymentVariable: boolean,
    regionId: number,
    paymentComponent: PaymentiframeComponent
  ) {

    let schoolAccountSetupComplete = await this.isAccountReady(regionId, price, payments, school);
    if (allowBatches && batchId <= 0) {
      toastr.error('Batch not selected');
      return;
    }
    if (!schoolAccountSetupComplete) {
      toastr.warning('School account is not ready for payment. Please contact your school administrator.');
      return;
    }
    if (price > 0 && regionId === 1) {
      paymentModal.modal('show');
      loadingPaymentVariable = true;
    }
    if (price > 0) {
      let paymentinfo: any;
      paymentinfo = regionId === 1 ? await payments.initiateModulePayment(moduleId, batchId).toPromise() : await payments.initiateStripeModulePayment(moduleId, batchId).toPromise();

      const paymenturl = paymentinfo.url;
      if (paymenturl && regionId == 1)
        paymentComponent.openPaymentWindow(paymenturl);
      else if (paymenturl && regionId != 1)
        await payments.openStripeCheckout(toastr, paymenturl);
      else
        loadingPaymentVariable = false;
    } else {
      await this.enrollformodule({
        moduleId: moduleId,
        batchId: batchId,
      })
        .toPromise();
      toastr.success('Successfully Enrolled');
      batchId = 0;
    }
  }

  
}
